import Header from './partials/Header'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const BASE_STAGE_WIDTH = 1080
const BASE_STAGE_HEIGHT = 1920

const setStageScaleVar = () => {
  if (typeof window === 'undefined') return

  // Use innerWidth/innerHeight for best mobile behavior.
  const vw = window.innerWidth || BASE_STAGE_WIDTH
  const vh = window.innerHeight || BASE_STAGE_HEIGHT

  const nextScale = Math.min(vw / BASE_STAGE_WIDTH, vh / BASE_STAGE_HEIGHT)
  const clamped = Number.isFinite(nextScale) && nextScale > 0 ? nextScale : 1

  document.documentElement.style.setProperty('--app-scale', String(clamped))
}

const MasterLayout = ({ children }) => {
  const { i18n } = useTranslation()
  const currentLanguage = (i18n.language || 'english').toLowerCase().startsWith('français') ? 'fr' : 'en'
  
  useEffect(() => {
    setStageScaleVar()

    window.addEventListener('resize', setStageScaleVar)
    window.addEventListener('orientationchange', setStageScaleVar)

    return () => {
      window.removeEventListener('resize', setStageScaleVar)
      window.removeEventListener('orientationchange', setStageScaleVar)
    }
  }, [])

  return (
    <>
      <div className="app-viewport">
        <div
          id="master-layout"
          className={`app-stage ${currentLanguage === 'fr' ? 'bg-soccer-fr-block-bg' : 'bg-soccer-en-block-bg'} bg-cover bg-center relative flex flex-col overflow-y-hidden`}
        >
          <Header />
          {children}
        </div>
      </div>
    </>
  )
}

export default MasterLayout
